"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LanguageModel", {
    enumerable: true,
    get: function() {
        return LanguageModel;
    }
});
const _zod = require("zod");
const LanguageModel = _zod.z.object({
    code: _zod.z.string({
        description: 'The unique identifier of the language.',
        invalid_type_error: 'Language code must be a string',
        required_error: 'Language code is required'
    }),
    name: _zod.z.string({
        description: 'The name of the language.',
        invalid_type_error: 'Language name must be a string',
        required_error: 'Language name is required'
    })
});

//# sourceMappingURL=language-model.js.map